export default {"src":"/_next/static/media/mana11.2e8aba53.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};